var GA = {

    register : function(category,action,title,value)
    {
        if(typeof(ga)!== 'undefined'){
            ga('send', 'event', category, action, title, value);
        }
    }

};
